import type { ReactNode, RefObject } from 'react'
import React from 'react'
import type { OverlayProps, PopoverProps } from 'react-bootstrap'
import { Overlay, Popover } from 'react-bootstrap'

export type BasePopoverProps = {
  show: boolean
  setShow: (value: boolean) => void
  target: OverlayProps['target']
  placement?: PopoverProps['placement']
  name: string
  children: ReactNode
  header?: ReactNode
  focusRef?: RefObject<HTMLElement>
  container?: OverlayProps['container']
}
export const BasePopover = ({
  show,
  setShow,
  target,
  placement = 'right',
  name,
  children,
  header,
  focusRef,
  container,
}: BasePopoverProps) => {
  // A react-select inside the popover portals its menu to document.body (`useReactSelect`), outside the popover, so
  // picking an option with the mouse reads as an outside click; the keyboard fires no click and so never closed it.
  const onHide: OverlayProps['onHide'] = (event) => {
    if (event?.target instanceof Element && event.target.closest('.react-select__menu-portal')) return
    setShow(false)
  }

  // A synchronously autofocused input scrolls itself into view while Popper still holds the overlay at its
  // pre-measurement position, so focus only the handed element after the overlay has entered and been positioned.
  const onEntered: OverlayProps['onEntered'] = () => {
    focusRef?.current?.focus({ preventScroll: true })
  }

  return (
    <Overlay
      show={show}
      target={target}
      placement={placement}
      rootClose={true}
      onHide={onHide}
      onEntered={onEntered}
      container={container}
    >
      <Popover id={`${name}-pop-over`} className="fw-normal fs-5 shadow-lg">
        <Popover.Header>{header}</Popover.Header>
        <Popover.Body style={{ width: '350px', maxHeight: '80vh', overflow: 'auto' }}>{children}</Popover.Body>
      </Popover>
    </Overlay>
  )
}
